export default __webpack_public_path__ + "static/media/back.fe75ab74.mp3";